const termsOfService = {
  title: 'Pogoji uporabe',
  description:
    'Pred nadaljevanjem uporabe aplikacije prosimo, da preberete in sprejmete pogoje uporabe.',
  summaryTitle: 'Ključne točke:',
  titleLine1: 'Medicinska uporaba',
  summaryLine1: 'To orodje je namenjeno za usposobljeno medicinsko osebje.',
  titleLine2: 'Neodvisno preverjanje',
  summaryLine2:
    'To orodje uporablja umetno inteligenco, ki lahko dela napake. Uporabnik mora neodvisno preveriti vso vsebino, ustvarjeno s pomočjo te aplikacije.',
  titleLine3: 'Odgovornost uporabnika',
  summaryLine3:
    'Uporabnik prevzema polno odgovornost za točnost in pravilnost poročil in izvidov, narejenih s pomočjo tega orodja.',
  description1: 'Z nadaljevanjem, se strinjate s celotnimi ',
  linkHref: 'https://medical.voicefill.ai/terms-and-conditions.html',
  linkText: 'pogoji uporabe',
  description2: '.',
  acceptTerms: 'Strinjam se',
};

export default termsOfService;
